import React from 'react';
import classnames from 'classnames';

import { ButtonBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';
import { useUserContext } from '@hydra/common/context';
import { useI18n } from '@hydra/common/customHooks';
import { isLite } from '@hydra/utils/userUtil';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2)
  },
  tab: {
    padding: theme.spacing(1),
    maxWidth: 200,
    marginLeft: 0,
    marginRight: 0,
    fontWeight: theme.typography.fontWeightSemibold,
    fontSize: theme.typography.fontSizeRoot,
    color: theme.palette.text.primary,
    '&:hover, &:active, &:focus': {
      outline: 'none',
      textDecoration: 'none',
      color: theme.palette.primary.main
    },
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    }
  },
  active: {
    borderBottom: `${theme.shape.borderRadius}px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  }
}));

interface ICreationToolbar {
  active: 'project' | 'review'
}

function CreationToolbar ({ active }: ICreationToolbar) {
  const { locale } = useI18n();
  const { user } = useUserContext();
  const maxProjects = user?.maxProjects || 0;
  const classes = useStyles();
  const isLiteUser = isLite(user);

  return (
    <div className={classes.root}>
      {(maxProjects > 0 || isLiteUser) && (
        <ButtonBase
          disabled={active === 'project'}
          href={`/${locale}/create/project`}
          className={classnames(
            'nr-creation-menu-projects-tab',
            classes.tab,
            {
              [classes.active]: active === 'project'
            }
          )}
        >
          <Translate content='cflow_toolbar_project_tab_label' />
        </ButtonBase>
      )}
      <ButtonBase
        disabled={active === 'review'}
        href={`/${locale}/create/review`}
        className={classnames(
          'nr-creation-menu-reviews-tab',
          classes.tab,
          {
            [classes.active]: active === 'review'
          }
        )}
      >
        <Translate content='cflow_toolbar_review_tab_label' />
      </ButtonBase>
    </div>
  );
}

export default CreationToolbar;
